import { render, staticRenderFns } from "./claim-list-content.vue?vue&type=template&id=2708f0fb&scoped=true&"
import script from "./claim-list-content.vue?vue&type=script&lang=js&"
export * from "./claim-list-content.vue?vue&type=script&lang=js&"
import style0 from "./claim-list-content.vue?vue&type=style&index=0&id=2708f0fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2708f0fb",
  null
  
)

export default component.exports